/**
 * Currency Formatter Utility
 *
 * Smart money formatter that shows decimals only when non-zero.
 * Round prices display without decimals (e.g., €155, $155).
 * Non-round prices display with decimals (e.g., €89,90, $89.90).
 *
 * Works for any 2-decimal Shopify money format — strips the trailing
 * `,00` or `.00` for round prices, preserves decimals for non-round prices.
 *
 * Usage:
 *   formatMoney(8990, '€{{amount_with_comma_separator}}')  // => "€89,90"
 *   formatMoney(15500, '€{{amount_with_comma_separator}}') // => "€155"
 */

function formatWithDelimiters(number, precision, thousands, decimal) {
  const p = precision != null ? precision : 2;
  const t = thousands || ',';
  const d = decimal || '.';

  const fixed = (number / 100.0).toFixed(p);
  const parts = fixed.split('.');
  const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${t}`);
  const centsPart = parts[1] ? d + parts[1] : '';

  return dollars + centsPart;
}

function formatMoney(cents, format) {
  let amount = cents;
  if (typeof amount === 'string') {
    amount = parseInt(amount.replace('.', ''), 10);
  }

  if (amount == null || Number.isNaN(amount)) {
    return '';
  }

  const formatString = format || (typeof Shopify !== 'undefined' && Shopify.money_format) || '';
  if (typeof formatString !== 'string') {
    return '';
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const matchResult = formatString.match(placeholderRegex);

  if (!matchResult || !matchResult[1]) {
    return formatWithDelimiters(amount, 2);
  }

  let value = '';

  const isRound = amount % 100 === 0;

  switch (matchResult[1]) {
    case 'amount':
      value = formatWithDelimiters(amount, 2);
      if (isRound) value = value.replace(/\.00$/, '');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(amount, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(amount, 2, '.', ',');
      if (isRound) value = value.replace(/,00$/, '');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(amount, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(amount, 2, "'", '.');
      if (isRound) value = value.replace(/\.00$/, '');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(amount, 2, ' ', ',');
      if (isRound) value = value.replace(/,00$/, '');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(amount, 0, ' ', ',');
      break;
    default:
      value = formatWithDelimiters(amount, 2);
      if (isRound) value = value.replace(/[.,]00$/, '');
  }

  return formatString.replace(placeholderRegex, value);
}

window.formatMoney = formatMoney;
